// src/pages/Workflows/Execucoes/components/ExecucoesList.js

import React from 'react';

const ESTADO_ICONE = {
  pending: '⏳',
  running: '🔄',
  completed: '✅',
  failed: '❌',
  cancelled: '🚫',
};

const ESTADO_COR = {
  completed: '#16a34a',
  failed: '#dc2626',
  running: '#2563eb',
  pending: '#94a3b8',
  cancelled: '#94a3b8',
};

export default function ExecucoesList({ execucoes, execucaoSelecionada, onSelecionar, loading }) {
  if (loading) return <div className="exec-list-loading">A carregar...</div>;

  if (execucoes.length === 0) {
    return <div className="exec-list-empty">Ainda não existem execuções para este workflow.</div>;
  }

  return (
    <div className="exec-list">
      {execucoes.map(e => {
        const selecionado = execucaoSelecionada?.id === e.id;
        const data = new Date(e.iniciado_em).toLocaleString('pt-PT', {
          day: '2-digit', month: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit',
        });

        return (
          <div
            key={e.id}
            className={`exec-list-item${selecionado ? ' exec-list-item--selected' : ''}`}
            onClick={() => onSelecionar(e.id)}
          >
            <span style={{ fontSize: '1.1rem' }}>{ESTADO_ICONE[e.estado] || '❓'}</span>
            <div className="exec-list-item-info">
              <span className="exec-list-item-data">{data}</span>
              <span
                className="exec-list-item-estado"
                style={{ color: ESTADO_COR[e.estado] }}
              >
                {e.estado}
              </span>
            </div>
            {e.duracao_seg != null && (
              <span className="exec-list-item-dur">{e.duracao_seg}s</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
